<template>
<div class="poisearch-container">
    <div class="searchbar" :class="{'with-expansion': suggestions.length > 0 || filtersVisible}">
        <span class="ai-icon-wrap">
            <img class="ai-icon" src="../assets/icons/search/location.png" alt="Location" />
        </span>
        <vs-input id="poiSearch" :placeholder="$t('explore.search.placeholder')" :loading="timer != null" v-model="search" v-on:keyup.enter="enterEvent" />
        <vs-button circle transparent @click="filtersVisible = !filtersVisible">
            <vs-avatar badge-color="primary" badge-position="top-right" size="28" square>
                <img v-if="filtersVisible" src="../assets/icons/search/filters-active.png" style="width: 24px;" />
                <img v-else src="../assets/icons/search/filters.png" style="width: 24px;" />

                <template #badge v-if="appliedFiltersCount > 0">
                    {{appliedFiltersCount }}
                </template>
            </vs-avatar>

        </vs-button>
        <vs-button circle class="search-btn" @click="doSearch()">
            <img src="../assets/icons/search/search.png" style="width: 18px;" />

        </vs-button>
    </div>
    <div class="mobile-targets" v-if="isMobile">
        <div class="targets-scroll">
            <button
                v-for="target in targets"
                :key="target.id"
                class="chip"
                :class="{'selected': filters.target_ids.includes(target.id)}"
                type="button"
                @click="toggleTarget(target.id)"
            >
                <img
                    v-if="targetsIcons && targetsIcons[target.id]"
                    :src="targetsIcons[target.id]"
                    alt=""
                />
                <span class="label">{{ target.name }}</span>
            </button>
        </div>
    </div>
    <div class="suggestions" v-if="!filtersVisible && (suggestions.length > 0 || noResult)">
        <SearchSuggestion v-for="suggestion in suggestions" :key="suggestion.id" :poi="suggestion" @click.native="chooseSuggestion(suggestion)" />
        <div v-if="noResult">
            <p style="margin: 0; padding: 20px;">{{ $t('explore.search.noResults') }}</p>
        </div>
    </div>

    <SearchFilters :user="user" :auto="auto" v-show="filtersVisible" v-if="!isMobile" :oldfilters="filters" :change="applyFilters" :close="() => {filtersVisible = false}"/>


</div>
</template>

<script>
import SearchFilters from './SearchFilters.vue';
import SearchSuggestion from './SearchSuggestion.vue';
import AIAssistant from './AIAssistant.vue';
import {
    apiCall
} from '../utils/ApiMiddleware';
import POI from './elements/POI.vue';
import { GlobalEventEmitter } from '../utils/GlobalEventEmitter';
export default {
    name: "poiSearch",
    props: {
        isMobile: Boolean,
        userCoords: {
            type: Array,
            default: function () {
                return null;
            }
        },

        auto: { // load suggestions
            type: Boolean,
            default: true
        },

        user: {
            type: Object,
            default: null
        },

        oldfilters: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            suggestions: [],
            search: '',
            filtersVisible: false,
            filtersMobilePanel: null,
            poiDetailsPanel: null,
            timer: null,
            filters: {
                country_id: null,
                state_id: null,
                city_id: null,
                target_ids: [],
                only_place_to_discover: false,
                only_my_places: false,
                ratings: [],
            },
            noResult: false,
            nearestPoi: null,
            aiPanel: null
        }
    },

    created() {
        document.addEventListener("click", this.handleOutOfElementClick);
        // Close the AI Assistant if route changes (router emits aiPanelForceClose)
        try {
            this._aiForceCloseHandler = () => {
                if (this.aiPanel) {
                    try { this.aiPanel.hide(); } catch (e) {console.debug('aiPanel hide failed');}
                    this.aiPanel = null;
                }
                try { GlobalEventEmitter.$emit('aiPanelClose'); } catch (e) {console.debug('aiPanelClose emit failed');}
            };
            GlobalEventEmitter.$on('aiPanelForceClose', this._aiForceCloseHandler);
            // open AI assistant on external event (e.g., from map control)
            try {
                this._aiOpenHandler = () => { this.openAIAssistant(); };
                GlobalEventEmitter.$on('openAIAssistant', this._aiOpenHandler);
            } catch (e) { console.debug('openAIAssistant on failed'); }
        } catch (e) {console.debug('aiPanelForceClose on failed');}

        // Force-close any open POI panel (used to avoid stacking sheets from different sources)
        try {
            this._poiForceCloseHandler = () => {
                if (this.poiDetailsPanel) {
                    try { this.poiDetailsPanel.hide(); } catch (e) { console.debug('poiDetailsPanel hide failed'); }
                    // Do not null here; the panel promise handler cleans up safely.
                }
            };
            GlobalEventEmitter.$on('poiPanelForceClose', this._poiForceCloseHandler);
        } catch (e) { console.debug('poiPanelForceClose on failed'); }

        if(this.oldfilters != null){
            this.search = this.oldfilters.search;
            this.filters = JSON.parse(JSON.stringify(this.oldfilters));
            console.log(this.filters);
        }
    },

    beforeDestroy() {
        document.removeEventListener("click", this.handleOutOfElementClick);
        try {
            if (this._aiForceCloseHandler) {
                GlobalEventEmitter.$off('aiPanelForceClose', this._aiForceCloseHandler);
                this._aiForceCloseHandler = null;
            }
            if (this._aiOpenHandler) {
                GlobalEventEmitter.$off('openAIAssistant', this._aiOpenHandler);
                this._aiOpenHandler = null;
            }
            if (this._poiForceCloseHandler) {
                GlobalEventEmitter.$off('poiPanelForceClose', this._poiForceCloseHandler);
                this._poiForceCloseHandler = null;
            }
        } catch (e) {console.debug('aiPanelForceClose off failed');}
    },

    watch: {
        search(n) {
            if (!this.auto) {
                return;
            }
            this.noResult = false;
            if (n == '') {
                this.suggestions = []
                if (this.timer != null) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
            } else {
                if (this.timer != null) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.doSearch()
                }, 1000);
            }
        },
        filtersVisible(n) {
            if (n) {
                this.noResult = false;
            }
            var vm = this;
            if (!this.isMobile) {
                return;
            }

            if (n) {
                this.filtersMobilePanel = this.$showPanel({
                    component: SearchFilters,
                    openOn: 'bottom',
                    cssClass: 'filters-mobile-panel',
                    props: {
                        change: this.applyFilters,
                        close: () => {
                            this.filtersVisible = false
                        },
                        isMobile: vm.isMobile,
                        oldfilters: this.filters,
                        user: this.user,
                        showTargets: false,
                    }
                });
                this.filtersMobilePanel.promise
                    .then(() => {
                        vm.filtersVisible = false
                    });
            } else {
                if (this.filtersMobilePanel != null) {
                    this.filtersMobilePanel.hide();
                    this.filtersMobilePanel = null;
                }
            }

        },
    },

    computed: {
        targets() {
            return this.$TARGETS.data;
        },
        targetsIcons(){
            return this.$TARGETS.icons;
        },
        appliedFiltersCount() {
            let appliedFiltersNames = Object.keys(this.filters).filter(e => (
                (typeof(this.filters[e]) == 'boolean' && this.filters[e] != false) ||
                (typeof(this.filters[e]) == 'object' && this.filters[e] != null && this.filters[e].length > 0) ||
                (typeof(this.filters[e]) == 'string' && this.filters[e] != '') ||
                (typeof(this.filters[e]) == 'number' && this.filters[e] != null)
            ));

            console.log(appliedFiltersNames);

            // do not count the search or target type pills (these chips are outside the filters panel)
            appliedFiltersNames = appliedFiltersNames.filter(e => e != 'search' && e != 'target_ids');

            return appliedFiltersNames.length;
        }
    },

    methods: {
        openAIAssistant() {
            if (this.aiPanel) {
                try {
                    this.aiPanel.hide();
                } catch (e) {
                    // best-effort hide; ignore but log to help debugging
                    console.warn('Failed to hide AI panel:', e);
                }
                GlobalEventEmitter.$emit('aiPanelClose');
                this.aiPanel = null;
            }
            const isMobile = this.isMobile;
            GlobalEventEmitter.$emit('aiPanelOpen');
            this.aiPanel = this.$showPanel({
                component: AIAssistant,
                openOn: isMobile ? 'bottom' : 'right',
                cssClass: 'ai-assistant-panel ' + (isMobile ? 'mobile-dialog-padding' : ''),
                props: {
                    isMobile: isMobile,
                    userCoords: this.userCoords,
                    user: this.user,
                    close: () => {
                        if (this.aiPanel) { this.aiPanel.hide(); this.aiPanel = null; }
                        GlobalEventEmitter.$emit('aiPanelClose');
                    }
                }
            });
            if (this.aiPanel && this.aiPanel.promise) {
                this.aiPanel.promise.then(() => { GlobalEventEmitter.$emit('aiPanelClose'); this.aiPanel = null; });
            }
        },
        handleOutOfElementClick(evt) {
            const flyoutEl = document.getElementsByClassName('poisearch-container')[0];
            // .vs-tootip is the class of the tooltip
            const flyoutEl2 = document.getElementsByClassName('vs-tooltip')[0];
            let targetEl = evt.target; // clicked element      
            do {
                if (targetEl == flyoutEl || targetEl == flyoutEl2 || (targetEl.className && targetEl.className == 'vs__deselect')){
                    return;
                }
                // Go up the DOM
                targetEl = targetEl.parentNode;
            } while (targetEl);
            // This is a click outside.      
            this.suggestions = [];
            this.filtersVisible = false;
            this.noResult = false;
        },

        enterEvent() {
            if (!this.auto) {
                this.doSearch();
            }
        },

        toggleTarget(targetId) {
            if (!this.filters.target_ids) {
                this.filters.target_ids = [];
            }
            const idx = this.filters.target_ids.indexOf(targetId);
            if (idx === -1) {
                this.filters.target_ids.push(targetId);
            } else {
                this.filters.target_ids.splice(idx, 1);
            }
            this.applyFilters(this.filters);
        },

        async applyFilters(filters) {
            if (filters != null) {
                this.filters = filters;
            }

            await this.doSearch(false);
            // apply filters to the map too
            this.$emit('search', {
                country_id: this.filters.country_id,
                state_id: this.filters.state_id,
                city_id: this.filters.city_id,
                target_ids: this.filters.target_ids,
                only_place_to_discover: this.filters.only_place_to_discover,
                only_my_places: this.filters.only_my_places,
                ratings: this.filters.ratings,
            }, this.nearestPoi)

        },

        async chooseSuggestion(suggestion) {
            this.search = '';
            this.suggestions = []
            if (suggestion.isCity || suggestion.isRegion || suggestion.isCountry) {
                const response = await apiCall('GET', '/pois', {
                    city_id: suggestion.isCity ? suggestion.id : undefined,
                    state_id: suggestion.isRegion ? suggestion.id : undefined,
                    country_id: suggestion.isCountry ? suggestion.id : undefined,
                    limit: 1
                });
                if (response.status == 200) {
                    if (response.data.data != null && response.data.data.length > 0) {
                        var nearestPoi = response.data.data[0];
                        nearestPoi.forced = true;
                        if (suggestion.isRegion) { // decrease zoom if is region
                            nearestPoi.preferredZoom = 9;
                        }

                        if(suggestion.isCountry){ // decrease more if is a whole country
                            nearestPoi.preferredZoom = 7;
                        }
                        this.$emit('search', {
                            state_id: this.filters.state_id,
                            city_id: this.filters.city_id,
                            country_id: this.filters.country_id,
                            target_ids: this.filters.target_ids,
                            only_place_to_discover: this.filters.only_place_to_discover,
                            only_my_places: this.filters.only_my_places,
                            ratings: this.filters.ratings,
                        }, nearestPoi)
                    } else {
                        this.suggestions = [];
                        this.noResult = true;
                    }
                } else if (response.status != 0) {
                    this.$vs.notification({
                        title: this.$t('common.messages.somethingWentWrong'),
                        text: this.$t('explore.search.error'),
                        color: 'danger',
                        position: 'top-right'
                    })
                }
            } else {
                if (this.isMobile) {
                    // Ensure we never stack POI sheets (search result panel, marker panel, etc.)
                    try { GlobalEventEmitter.$emit('poiPanelForceClose'); } catch (_) { /* no-op */ }

                    GlobalEventEmitter.$emit('setMobileNavbarVisible', false);
                    GlobalEventEmitter.$emit('poiPanelOpen');
                    GlobalEventEmitter.$emit('invalidateMap');
                    setTimeout(() => {
                        GlobalEventEmitter.$emit('centerWithOffset', { lat: suggestion.latitude, lng: suggestion.longitude });
                    }, 80);
                    setTimeout(() => {
                        GlobalEventEmitter.$emit('centerWithOffset', { lat: suggestion.latitude, lng: suggestion.longitude });
                    }, 350);

                    let closedByPoi = false;
                    const panel = this.$showPanel({
                        component: POI,
                        openOn: 'bottom',
                        cssClass: 'poi-mobile-panel',
                        props: {
                            poiId: suggestion.id,
                            user: this.user,
                            isMobile: true,
                            close: () => {
                                // This callback is invoked by the POI component (internal close).
                                // POI.vue already emits poiPanelClose + map resize events in that flow.
                                closedByPoi = true;
                                try { panel.hide(); } catch (_) { /* no-op */ }
                            }
                        }
                    });
                    this.poiDetailsPanel = panel;
                    if (panel && panel.promise) {
                        panel.promise.then(() => {
                            // Only clear if we're still the active panel (avoid races when opening another POI quickly)
                            if (this.poiDetailsPanel === panel) {
                                this.poiDetailsPanel = null;
                            }
                            // If POI.vue initiated the close, it already handled layout events.
                            if (closedByPoi) {
                                return;
                            }
                            // External close (e.g., map tap or force-close) -> restore layout here.
                            try {
                                GlobalEventEmitter.$emit('setMobileNavbarVisible', true);
                                GlobalEventEmitter.$emit('poiPanelClose');
                                GlobalEventEmitter.$emit('poiSheetHeightChanged', 0);
                                GlobalEventEmitter.$emit('invalidateMap');
                            } catch (_) { /* no-op */ }
                        });
                    }
                } else {
                    this.$router.push({
                        name: 'Scheda del luogo',
                        params: {
                            id: suggestion.id
                        }
                    })
                }
            }

        },
        focusInput() {
            document.getElementById("vs-input--poiSearch").focus();
        },

        async doSearch(suggestions = true) {
            if (!this.auto) {
                suggestions = false;
            }

            this.nearestPoi = null;
            this.noResult = false;
            var params = {
                search: this.search,
                limit: 3,
                actual_latitude: this.userCoords != null ? this.userCoords[0] : undefined,
                actual_longitude: this.userCoords != null ? this.userCoords[1] : undefined,
            };

            if (this.filters != null) {
                params = {
                    ...params,
                    ...this.filters
                };
            }

            this.$emit('query', this.search);

            const response = await apiCall('GET', '/pois', params);
            this.timer = null;
            if (response.status == 200) {
                if (response.data.data != null && response.data.data.length > 0) {
                    if (suggestions) {
                        this.suggestions = response.data.data;
                    } else {
                        this.suggestions = [];
                        this.nearestPoi = response.data.data[0];
                    }
                } else {
                    this.suggestions = [];
                    this.noResult = true;
                }

                this.filtersVisible = false;
            } else if (response.status != 0) {
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('explore.search.error'),
                    color: 'danger',
                    position: 'top-right'
                })
            }

            // Search for regions
            const response4 = await apiCall('GET', '/places/countries', {
                search: this.search,
                limit: 3
            });
            if (response4.status == 200) {
                if (response4.data.data != null && response4.data.data.length > 0) {
                    if (suggestions) {
                        this.suggestions = response4.data.data.map(e => ({
                            ...e,
                            isCountry: true
                        })).concat(this.suggestions);
                    }
                }
            } else if (response4.status != 0) {
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('explore.search.error'),
                    color: 'danger',
                    position: 'top-right'
                })
            }


            // Search for regions
            const response3 = await apiCall('GET', '/places/states', {
                search: this.search,
                limit: 3
            });
            if (response3.status == 200) {
                if (response3.data.data != null && response3.data.data.length > 0) {
                    if (suggestions) {
                        this.suggestions = response3.data.data.map(e => ({
                            ...e,
                            isRegion: true
                        })).concat(this.suggestions);
                    }
                }
            } else if (response3.status != 0) {
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('explore.search.error'),
                    color: 'danger',
                    position: 'top-right'
                })
            }

            // Search for cities
            const response2 = await apiCall('GET', '/places/cities', {
                search: this.search,
                limit: 3
            });
            if (response2.status == 200) {
                if (response2.data.data != null && response2.data.data.length > 0) {
                    if (suggestions) {
                        this.suggestions = response2.data.data.map(e => ({
                            ...e,
                            isCity: true
                        })).concat(this.suggestions);
                    }
                }
            } else if (response2.status != 0) {
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('explore.search.error'),
                    color: 'danger',
                    position: 'top-right'
                })
            }

            if (this.suggestions.length > 0) {
                this.noResult = false;
            }
        }
    },
    components: {
        SearchSuggestion,
        SearchFilters
    },

}
</script>

<style scoped>
.poisearch-container {
    position: absolute;
    left: 80px;
    top: 15px;
    z-index: 2100;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: visible;

    box-sizing: border-box;
}

.suggestions {
    background: white;
    display: flex;
    align-items: center;
    width: 100%;
    flex-direction: column;
    box-sizing: border-box;

    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    overflow: hidden;
}
.suggestions > * {
    animation: ps-fadeUp .22s ease both;
}
@keyframes ps-fadeUp {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
}

.search-btn {
    width: 40px;
    height: 40px;
}

/* AI icon animation: float + stronger aura glow + hue shimmer */
.ai-icon {
    height: 30px;
    width: auto;
    transform-origin: center;
    position: relative;
    z-index: 1; /* sit above aura layers */
    animation:
        aiFloat 3s ease-in-out infinite,
        aiGlow 1.4s ease-in-out infinite,
        aiHue 7s linear infinite;
    /* brighter baseline */
    filter: drop-shadow(0 0 12px rgba(239,126,24,0.50)) saturate(140%) brightness(1.05);
    will-change: transform, filter;
}
/* Aura container to host pseudo-elements (works better than pseudo on <img>) */
.ai-icon-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin-right: 6px;
    overflow: visible;
}
/* Soft radial aura behind the icon */
.ai-icon-wrap::before {
    content: '';
    position: absolute;
    inset: -6px;
    border-radius: 999px;
    background: radial-gradient(50% 50% at 50% 50%, rgba(239,126,24,0.55) 0%, rgba(239,126,24,0.00) 65%);
    filter: blur(10px);
    opacity: 0.8;
    animation: aiAura 1.9s ease-in-out infinite;
    z-index: 0;
    pointer-events: none;
}
/* Shimmer sweep (conic highlight) */
.ai-icon-wrap::after {
    content: '';
    position: absolute;
    inset: -10px;
    border-radius: 999px;
    background: conic-gradient(from 0deg, rgba(255,255,255,0) 0deg, rgba(255,255,255,0.9) 30deg, rgba(255,255,255,0) 60deg);
    mix-blend-mode: screen;
    filter: blur(8px);
    opacity: 0.85;
    animation: aiSweep 2.6s linear infinite;
    z-index: 0;
    pointer-events: none;
}
/* Speed up aura on focus/hover for more presence */
.searchbar:hover .ai-icon-wrap::before,
.searchbar:focus-within .ai-icon-wrap::before {
    animation-duration: 1.5s;
}
.searchbar:hover .ai-icon-wrap::after,
.searchbar:focus-within .ai-icon-wrap::after {
    animation-duration: 2s;
}
/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
    .ai-icon-wrap::before,
    .ai-icon-wrap::after {
        animation: none;
    }
}
/* Keyframes for aura layers */
@keyframes aiAura {
    0%, 100% { transform: scale(1);   opacity: 0.65; filter: blur(10px); }
    50%      { transform: scale(1.18); opacity: 0.95; filter: blur(14px); }
}
@keyframes aiSweep {
    from { transform: rotate(0deg) scale(1);   opacity: 0.9; }
    to   { transform: rotate(360deg) scale(1); opacity: 0.9; }
}
@keyframes aiFloat {
    0%   { transform: translateY(0) scale(1) rotate(0deg); }
    50%  { transform: translateY(-4px) scale(1.06) rotate(2deg); }
    100% { transform: translateY(0) scale(1) rotate(0deg); }
}
@keyframes aiGlow {
    0%, 100% { filter: drop-shadow(0 0 10px rgba(239,126,24,0.40)) saturate(135%) brightness(1.05); }
    40%      { filter: drop-shadow(0 0 24px rgba(239,126,24,0.85)) saturate(165%) brightness(1.12); }
    60%      { filter: drop-shadow(0 0 18px rgba(239,126,24,0.65)) saturate(150%) brightness(1.08); }
}
@keyframes aiHue {
    0%   { filter: hue-rotate(0deg)   drop-shadow(0 0 12px rgba(239,126,24,0.50)) saturate(140%) brightness(1.05); }
    50%  { filter: hue-rotate(28deg)  drop-shadow(0 0 28px rgba(239,126,24,0.90)) saturate(170%) brightness(1.12); }
    100% { filter: hue-rotate(0deg)   drop-shadow(0 0 12px rgba(239,126,24,0.50)) saturate(140%) brightness(1.05); }
}
/* Speed up on hover/focus for a responsive feel */
.searchbar:hover .ai-icon,
.searchbar:focus-within .ai-icon {
    animation-duration: 3.8s, 1.8s, 9s;
}
/* Respect reduced motion */
@media (prefers-reduced-motion: reduce) {
    .ai-icon {
        animation: none;
    }
}

.searchbar {
    background: rgba(255, 255, 255, 0.55);
    -webkit-backdrop-filter: saturate(150%) blur(14px);
    backdrop-filter: saturate(150%) blur(14px);
    border: 1px solid rgba(255, 255, 255, 0.35);
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 24px;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    box-shadow: 0 10px 30px rgba(16, 24, 40, 0.18);
    z-index: 1950;
    margin-bottom: 6px;
    transition: box-shadow .25s ease, transform .12s ease, background-color .25s ease, border-color .25s ease, backdrop-filter .25s ease;
    will-change: transform, box-shadow;
}

.searchbar.with-expansion {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin-bottom: 0!important;
}
.searchbar:focus-within {
    box-shadow: 0 14px 36px rgba(16, 24, 40, 0.22);
    transform: translateY(-1px);
}

.mobile-targets {
    top: 55px;
    width: 100vw;
    position: absolute;
    z-index: 1960; /* ensure chips render above searchbar shadow */
}

.targets-scroll button:first-child {
    margin-left: 20px;
}

.targets-scroll {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    overflow-y: visible;
    padding: 8px 4px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
}
.targets-scroll::-webkit-scrollbar { display: none; }

.mobile-targets .chip {
    background: rgba(255, 255, 255, 0.5);
    -webkit-backdrop-filter: saturate(150%) blur(10px);
    backdrop-filter: saturate(150%) blur(10px);
    border: 1px solid rgba(39, 48, 63, 0.12);
    border-radius: 999px;
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.10);
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
    min-width: max-content;
    padding: 8px 12px;
    height: auto;
    min-height: 36px;
    font-size: 13px;
    white-space: nowrap;
    color: #27303f;
    outline: none;
    appearance: none;
    transition: background-color .2s ease, color .2s ease, border-color .2s ease, box-shadow .2s ease, transform .12s ease;
    will-change: transform;
}
.mobile-targets .chip:active {
    transform: scale(.96);
    box-shadow: 0 3px 10px rgba(16,24,40,0.12);
}

.mobile-targets .chip.selected {
    background: var(--primary);
    color: #fff;
    border-color: var(--primary);
    box-shadow: 0 4px 12px rgba(239, 126, 24, 0.35);
}

.mobile-targets .chip .label {
    line-height: 1;
    display: inline-block;
}

.mobile-targets .chip img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
}
.mobile-targets .chip.selected img {
    filter: brightness(10) invert(1);
}

/* MOBILE */
@media (max-width: 600px) {
    .poisearch-container {
        top: 20px;
        left: 25px;
        right: 25px;
        width: auto;
        padding-left: 0;
        padding-right: 0;
    }

    input {
        flex-grow: 1;
    }

    .search-btn {
        width: 40px;
        height: 40px;
        min-width: 40px;
    }
}
</style><style>
.poisearch-container .vs-input {
    background: transparent;
}

/* MOBILE */
@media (max-width: 600px) {

    ::placeholder {
        font-size: 18px !important;
        color: rgba(var(--grey-75));
    }

    input.vs__search {
        height: 30px;
    }

    #poiSearch {
        width: calc(100% - 130px) !important;
    }
}


.poisearch-container .vs-avatar {
    background: transparent!important;
    box-shadow: none!important;
}

.poisearch-container .vs-avatar-content:hover img {
    transform: unset!important;
}

.tourial-app.tourial-native .poisearch-container {
    top: max(20px, calc(20px + env(safe-area-inset-top)))!important;
}
.slideout.filters-mobile-panel {
    height: 420px !important;
    max-height: 420px !important;
}
.poi-mobile-panel {
    max-height: calc(75vh - 80px)!important;
    height: calc(75vh - 80px)!important;
    border-top-left-radius: 18px!important;
    border-top-right-radius: 18px!important;
}
/* AI assistant panel sizing */
/* Mobile: leave 100px at the top and respect bottom safe area in native app */
.ai-assistant-panel {
    z-index: 2205 !important;
    height: calc(
    100dvh
    - env(safe-area-inset-bottom, 34px)
    - 40px
    )!important;
    max-height: calc(
    100dvh
    - env(safe-area-inset-bottom, 34px)
    - 40px
    )!important;
    border-top-left-radius: 18px!important;
    border-top-right-radius: 18px!important;
    padding-left: 0!important;
    padding-right: 0!important;
    box-sizing: border-box!important;
    /* vue2-slideout-panel sets overflow-y:auto on .slideout, which makes the
       whole sheet (header, close button, chips, composer) scroll as one block.
       The conversation area (.ai-content) handles its own scrolling instead. */
    overflow: hidden!important;
}
/* desktop/right panel width */
@media (min-width: 601px) {
    .ai-assistant-panel {
        z-index: 2205 !important;
        width: 420px!important;
        max-width: 420px!important;
        height: 100%!important;
        max-height: 100%!important;
        border-top-left-radius: 18px!important;
        border-bottom-left-radius: 18px!important;
        border-top-right-radius: 0!important;
        border-bottom-right-radius: 0!important;
        padding-bottom: 24px!important;

    }
}

.suggestions {
    z-index: 2000!important;
}
</style>
